import type { ReactNode } from 'react';
import { cn } from '~/utils';

export function SectionPanelHeader({
  title,
  aside,
  className,
}: Readonly<{
  title: ReactNode;
  aside?: ReactNode;
  className?: string;
}>) {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-3 bg-neut-bg px-4 py-2',
        className
      )}
    >
      <h2 className="text-xs font-semibold text-neut-sec uppercase tracking-wide">
        {title}
      </h2>
      {aside}
    </div>
  );
}

export function SectionPanel({
  title,
  aside,
  children,
  bodyClassName = 'p-4',
}: Readonly<{
  title?: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
  bodyClassName?: string;
}>) {
  return (
    <div className="border border-neut-border rounded-lg overflow-hidden bg-white">
      {title !== undefined && (
        <SectionPanelHeader title={title} aside={aside} />
      )}
      <div className={bodyClassName}>{children}</div>
    </div>
  );
}
